import { createReference } from '@quromedical/fhir-common';
import { getLinkToPatientResource } from 'components/fhir';
import { ActionList } from 'design-system';
import { strings } from 'strings';
import { Item } from './Item';
import type { BaseTaskList } from './internal';
import { List } from './List';

export const TaskList: BaseTaskList = (props) => {
  const { addNote, tasks, error, isLoading, setStatus, setOwner, invalidate } =
    props;

  return (
    <List
      loading={isLoading}
      onFilterChange={setStatus}
      onFilterSecondaryChange={setOwner}
    >
      {error ? (
        <ActionList.Item
          id="error"
          title={strings.GenericErrorMessage}
          subTitle={strings.ErrorCardTitle}
          onPress={invalidate}
        />
      ) : null}
      {tasks.map((task) => {
        const taskOverdueColor =
          task.status === 'failed' ? 'status-warning' : undefined;
        task.focus = task.focus ? task.focus : createReference('Task', task.id);

        const onSelect = props.navigate
          ? () => {
              const link = getLinkToPatientResource(task.for, task.focus);

              if (!link) {
                return;
              }

              props.navigate?.(link);
            }
          : undefined;

        return (
          <Item
            key={task.id}
            task={task}
            onNoteAdd={addNote}
            onSelect={onSelect}
            showContent
            backgroundColor={taskOverdueColor}
            showName
          />
        );
      })}
    </List>
  );
};
